import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { BrandIq } from '../../brandiq.setup';
import { BrandIqDataCollectionFunnelTab, BrandIqAppInsightsTab } from './tabs';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent = BrandIq.pages.brandiqBasic;
const title = 'PAGE.BRANDIQ.BRANDIQ_BASIC.TITLE';
const tabs: TabPermission[] = [
  BrandIqDataCollectionFunnelTab,
  BrandIqAppInsightsTab,
];

export const BrandIqBasicPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
